import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from '@pancakeswap/uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Kanit', sans-serif;
  }
  body {
    // background: url(images/Background-10.jpg) no-repeat center center fixed;
    // background-size: cover;
    // background-color: ${({ theme }) => theme.colors.background};
    background-color:#292B32;
    img {
      height: auto;
      max-width: 100%;
    }
  }
`

export default GlobalStyle
